import React, { Fragment } from "react"
import { PageButton } from "./ButtonStyle";
import PropTypes from 'prop-types';

function Button({value,onClick,iconEnable,icon,...rest}) {
    return (
        <PageButton onClick={onClick} type="submit" {...rest}>{iconEnable?<Fragment><i className={`pi ${icon}`} style={{marginRight:"10px",fontSize:"14px"}}/>{value}</Fragment>:value}</PageButton>
    )
}
Button.propTypes = {
    value: PropTypes.string,
    onClick:PropTypes.func,
    iconEnable:PropTypes.bool,
    icon:PropTypes.string

}
export default Button;